import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "./Layout";
import { authService, profileService } from "../services";

const MENU = [
  { to: "/profile", icon: "👤", label: "ตั้งค่าสมาชิก" },
  { to: "/profile/address", icon: "📍", label: "ที่อยู่" },
  { to: "/profile/topup-game-history", icon: "📦", label: "ประวัติการเติมเกม" },
  { to: "/profile/topup-mobile-history", icon: "📦", label: "ประวัติการเติมเงินมือถือ" },
  { to: "/profile/topup-card-history", icon: "📦", label: "ประวัติสั่งซื้อบัตรเติมเงิน" },
  { to: "/profile/product-history", icon: "📦", label: "ประวัติสั่งซื้อสินค้า" },
];

export default function ProfileLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(authService.currentProfile());

  useEffect(() => {
    if (!authService.isLoggedIn()) {
      navigate("/login", { replace: true, state: { from: location.pathname } });
      return;
    }
    profileService.get().then(setProfile);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <section className="lt-profile-banner">
        <div className="lucid-container lt-profile-banner__inner">
          <div className="lt-profile-banner__avatar">
            {(profile?.fullname || profile?.email || "L").charAt(0).toUpperCase()}
          </div>

          <div style={{ flex: "1 1 320px" }}>
            <div className="lt-profile-banner__uid">UID {profile?.uid || "-"}</div>
            <div className="lt-profile-banner__name">{profile?.fullname || profile?.email}</div>
            <div className="lt-profile-banner__rank">
              {profile?.email} {profile?.phone ? `· ${profile.phone}` : ""}
            </div>
          </div>

          <div className="lt-profile-banner__credit">
            <small>สถานะบัญชี</small>
            <strong style={{ fontSize: 22 }}>{profile?.isVerified ? "ยืนยันแล้ว" : "รอยืนยัน"}</strong>
            <Link to="/topup/game" className="lt-btn lt-btn--teal lt-btn--pill lt-mt-24">
              เติมเกม
            </Link>
          </div>
        </div>
      </section>

      <div className="lucid-container" style={{ paddingBottom: 40 }}>
        <div className="lt-profile-layout">
          <aside className="lt-profile-menu">
            <h3>เมนูสำหรับผู้ใช้</h3>
            {MENU.map((item) => (
              <Link key={item.to} to={item.to} className={location.pathname === item.to ? "is-active" : ""}>
                <span>{item.icon}</span>
                {item.label}
              </Link>
            ))}
          </aside>

          <div>{children}</div>
        </div>
      </div>
    </Layout>
  );
}
